import { LanguageConst } from './resources/languageconst';
import { ThemeConst } from './resources/themeconst';
import { Property } from './property/property';
import { History } from "history";

export interface RouterBuilder
{
    setCurrentLanguage(languageConst: LanguageConst): RouterBuilder;
    setCurrentTheme(them: ThemeConst): RouterBuilder;
    setRouterHistory(history: History<any>, routingPath: string): RouterBuilder;
    setProperty(propery: Property): RouterBuilder;
    build(): RouterDataModelProps;
}

export interface RouterDataModelProps
{
    getCurrentLanguage(): LanguageConst;
    getCurrentTheme(): ThemeConst;
    getRouterHistory(): History<any>;
    getRoutingPath(): string;
    getProperty(): Property;
}

class RouterDataModelPropsImpl implements RouterDataModelProps
{
    constructor( private cuurentTheme: ThemeConst,
        private currentLanguage: LanguageConst, private routingPath: string,
        private history: History<any>, private property: Property)
    {

    }

    getProperty(): Property 
    {
       return this.property;
    }

    getCurrentLanguage(): LanguageConst {
        return this.currentLanguage;
    }
    getCurrentTheme(): ThemeConst {
        return this.cuurentTheme;
    }
    getRoutingPath(): string {
        return this.routingPath;
    }
    getRouterHistory(): History<any> {
       return this.history;
    }
}
export {RouterDataModelPropsImpl};
export class RouterBuilderImpl implements RouterBuilder
{
   private cuurentTheme: ThemeConst;
   private currentLanguage: LanguageConst;
   private history: History<any>;
   private routingPath: string;
   private property: Property;

    constructor()
    {

    }

    setProperty(property: Property): RouterBuilder 
    {
        this.property = property;

        return this;
    }

    setCurrentLanguage(languageConst: LanguageConst): RouterBuilder 
    {
        this.currentLanguage = languageConst;

        return this;
    }
    setCurrentTheme(themeConst: ThemeConst): RouterBuilder 
    {
        this.cuurentTheme = themeConst;

        return this;
    }
    setRouterHistory(history: History<any>, routingPath: string): RouterBuilder 
    {
        this.history = history;
        this.routingPath = routingPath;

        return this;
    }

    build(): RouterDataModelProps 
    {
        return new RouterDataModelPropsImpl(this.cuurentTheme, this.currentLanguage, this.routingPath,
            this.history, this.property);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/routerbuilder.tsx